import React from 'react';
import PropTypes from 'prop-types';
import { Colors, Spacing } from 'works/legacy/lib/style-helper';
import { Typography } from 'antd';
import { OnboardingListTemplateActions } from './onboarding-list-template-actions';
import OnboardingListTemplateLabel from './onboarding-list-template-label';
import OnboardingListTemplateField from './onboarding-list-template-field';
import { Link } from '@common/components';

const { Title } = Typography;

export function OnboardingListTemplateSummary(props) {
  const {
    worksListTemplate: worksOnboardingListTemplate,
    bottomElements,
    showActions,
    showDetails,
  } = props;

  return (
    <>
      <article className="OnboardingListTemplateSummary">
        <section className="summary-header">
          <Title level={2}>{worksOnboardingListTemplate.name}</Title>
          {showActions && (
            <OnboardingListTemplateActions
              worksListTemplate={worksOnboardingListTemplate}
            />
          )}
        </section>
        {showDetails && (
          <section className="d-flex">
            <table className="onboarding-list-template-details">
              <tbody>
                <tr>
                  <OnboardingListTemplateLabel label="Deadline Details" />
                  <OnboardingListTemplateField
                    value={
                      worksOnboardingListTemplate.complianceDeadlineDetails
                    }
                  />
                </tr>
                <tr>
                  <OnboardingListTemplateLabel label="Linked assignments" />
                  <OnboardingListTemplateField
                    value={
                      <>
                        <span className="onboarding-list-template-linked-assignments">
                          {worksOnboardingListTemplate.activeAssignmentsCount}
                        </span>
                        <Link
                          to={`/works/admin/templates/compliance-list/${worksOnboardingListTemplate.id}/link-assignments`}
                        >
                          + Add more
                        </Link>
                      </>
                    }
                  />
                </tr>
              </tbody>
            </table>
          </section>
        )}
        {bottomElements}
      </article>
      <style jsx>{`
        .OnboardingListTemplateSummary {
          margin: ${Spacing.baseSpacingPx} 0;
          padding: ${Spacing.baseSpacing}px;
          transition: all 0.1s ease-in-out;
          border-radius: 4px;
          background-color: ${Colors.elmHyperlight};
          border: 0;
        }
        .summary-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .onboarding-list-template-details {
          flex-grow: 1;
          line-height: 22px;
          display: inline-block;
        }
        .onboarding-list-template-linked-assignments {
          margin-right: 12px;
        }
      `}</style>
    </>
  );
}

OnboardingListTemplateSummary.propTypes = {
  worksListTemplate: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    complianceDeadlineDetails: PropTypes.string.isRequired,
    staffingRequestAssignmentsCount: PropTypes.number.isRequired,
    activeAssignmentsCount: PropTypes.number,
  }).isRequired,
  bottomElements: PropTypes.element,
  showActions: PropTypes.bool,
  showDetails: PropTypes.bool,
};
